import { render, staticRenderFns } from "./orgAccount.vue?vue&type=template&id=cc9008f6"
import script from "./orgAccount.vue?vue&type=script&lang=js"
export * from "./orgAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports